import { createFileRoute, useNavigate, useRouter } from "@tanstack/react-router"
import { CompanyDetailPage } from "@/components/dashboard/buyer/pages/CompanyDetailPage"

export const Route = createFileRoute("/browse-supplier/companies/$companyId")({
  validateSearch: (search: Record<string, unknown>): {
    companyType?: "internal" | "external" | "lead"
    companyName?: string
    category?: string
    source?: string
    returnUrl?: string
  } => ({
    companyType: (search.companyType as "internal" | "external" | "lead") || "internal",
    companyName: (search.companyName as string) || undefined,
    category: (search.category as string) || undefined,
    source: (search.source as string) || undefined,
    returnUrl: (search.returnUrl as string) || undefined,
  }),
  component: BrowseSupplierCompanyDetailRoute,
})

function BrowseSupplierCompanyDetailRoute() {
  const { companyId } = Route.useParams()
  const { companyType, source, returnUrl } = Route.useSearch()
  const navigate = useNavigate()
  const router = useRouter()

  const handleBack = () => {
    if (returnUrl) {
      router.history.push(returnUrl)
      return
    }
    if (source === "dashboard" || source === "overview" || source === "explore") {
      navigate({ to: "/explore" as any })
    } else {
      navigate({ to: "/browse-supplier" })
    }
  }

  return (
    <CompanyDetailPage
      companyId={companyId}
      companyType={companyType || "internal"}
      onBack={handleBack}
    />
  )
}
